import { useEffect, useRef } from "react";

const HIGHLIGHTS = [
  {
    icon: "ri-scales-line",
    title: "Atuação Estratégica",
    desc: "Cada caso é analisado com profundidade, combinando técnica jurídica e visão estratégica para os melhores resultados.",
  },
  {
    icon: "ri-user-heart-line",
    title: "Atendimento Personalizado",
    desc: "Proximidade e cuidado em cada etapa do processo, com comunicação clara e transparente com nossos clientes.",
  },
  {
    icon: "ri-award-line",
    title: "Experiência Multidisciplinar",
    desc: "Ampla atuação nas áreas empresarial, trabalhista, previdenciária e civil, integrando soluções completas.",
  },
  {
    icon: "ri-check-double-line",
    title: "Compromisso com Resultados",
    desc: "Dedicação total ao sucesso de cada cliente, com responsabilidade, ética e foco nas melhores resoluções.",
  },
];

export default function SobreSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll(".reveal");
            items.forEach((item, i) => {
              setTimeout(() => {
                item.classList.add("opacity-100", "translate-y-0");
                item.classList.remove("opacity-0", "translate-y-8");
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre" ref={sectionRef} className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text */}
          <div>
            <div className="reveal opacity-0 translate-y-8 transition-all duration-700 flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-rose-primary" />
              <span className="text-rose-primary text-xs font-medium uppercase tracking-widest">Sobre o Escritório</span>
            </div>
            <h2 className="reveal opacity-0 translate-y-8 transition-all duration-700 font-heading text-4xl lg:text-5xl text-grafite font-semibold leading-tight mb-6">
              Advocacia com propósito,<br />
              <em className="text-rose-primary not-italic">estratégia</em> e compromisso
            </h2>
            <p className="reveal opacity-0 translate-y-8 transition-all duration-700 text-grafite/65 text-base leading-relaxed mb-6">
              O <strong>SM Advogados</strong> é um escritório jurídico dedicado a oferecer soluções personalizadas e estratégicas para empresas e pessoas físicas de todo o Brasil.
            </p>
            <p className="reveal opacity-0 translate-y-8 transition-all duration-700 text-grafite/65 text-base leading-relaxed mb-10">
              Com atuação nas áreas empresarial, trabalhista, previdenciária e civil, unimos técnica jurídica apurada com atendimento humanizado, garantindo segurança jurídica e resultados eficientes em cada caso.
            </p>

            {/* Highlights grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {HIGHLIGHTS.map((item) => (
                <div key={item.title} className="reveal opacity-0 translate-y-8 transition-all duration-700 group p-5 rounded-xl border border-gray-light hover:border-rose-primary/30 hover:bg-rose-pale/30 transition-all">
                  <div className="w-9 h-9 flex items-center justify-center bg-rose-pale rounded-lg mb-3 group-hover:bg-rose-primary/15 transition-colors">
                    <i className={`${item.icon} text-rose-primary text-lg`} />
                  </div>
                  <h3 className="text-grafite font-semibold text-sm mb-1.5">{item.title}</h3>
                  <p className="text-grafite/55 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="reveal opacity-0 translate-y-8 transition-all duration-700 relative">
            <div className="relative rounded-2xl overflow-hidden w-full h-[600px]">
              <img
                src="https://storage.readdy-site.link/project_files/9db3cce5-c9f8-4636-a3f8-f10d86795543/d6fe4151-2fad-40ff-8006-81273c40b736_SM-ADVOGADOS.jpg?v=c803b7aa7ac2731c924960bdededd735"
                alt="Advogada SM Advogados atendimento jurídico personalizado"
                title="Advocacia estratégica e personalizada – SM Advogados"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-grafite/30 to-transparent" />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl px-6 py-4 shadow-lg border border-gray-light">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-rose-pale rounded-full">
                  <i className="ri-shield-check-line text-rose-primary text-lg" />
                </div>
                <div>
                  <p className="text-grafite font-semibold text-sm">Ética e Transparência</p>
                  <p className="text-grafite/50 text-xs">OAB – Conformidade Total</p>
                </div>
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -top-4 -right-4 w-24 h-24 rounded-full bg-rose-pale -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
}
